import React from 'react';

const WhatsNewModal = ({ open, onClose, items = [] }) => {
  if (!open) return null;
  const list = items && items.length ? items : [
    'Installable PWA with offline support',
    'Faster loads via code-splitting',
    'Stronger security headers & CORS',
    'Cloudflare-ready API proxy (Pages Functions)'
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white dark:bg-zinc-900 rounded-xl shadow-2xl w-[90%] max-w-md p-6 border border-black/10 dark:border-glass">
        <h3 className="text-lg font-bold mb-2 text-zinc-900 dark:text-zinc-100">What’s New</h3>
        <p className="text-sm text-zinc-600 dark:text-zinc-300 mb-4">
          You’re on the latest version. Here are the highlights:
        </p>
        <ul className="list-disc pl-5 space-y-2 text-sm text-zinc-800 dark:text-zinc-200">
          {list.map((it, idx) => (
            <li key={idx}>{it}</li>
          ))}
        </ul>
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md bg-violet-600 text-white text-sm font-medium hover:bg-violet-700 transition-colors"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsNewModal;

